<template>
  <CoreDrawer
    :value="isVisible"
    :title="title"
    title-truncate
    data-qa="patient-profile-modal"
    @input="onInput"
  >
    <PatientProfileContent :patient-data="patientData" />

    <template #footer>
      <div class="d-flex pa-2">
        <v-btn
          data-qa="patient_profile__node_btn_close"
          class="branding-btn branding-btn--primary"
          block
          depressed
          @click="close"
        >
          {{ tStatic('Закрыть') }}
        </v-btn>
      </div>
    </template>
  </CoreDrawer>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import CoreDrawer from 'src/core/CoreDrawer/CoreDrawer.vue'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { PatientProfileData } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/PatientProfile/types'
import PatientProfileContent from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/PatientProfile/PatientProfileContent.vue'

const props = defineProps<{
  isVisible: boolean
  patientData: PatientProfileData
}>()

const emit = defineEmits(['close'])

const title = computed(() => `${tStatic('Пациент')} ${props.patientData.title}`.trim())

function close() {
  emit('close')
}

function onInput(value: boolean) {
  if (!value) {
    close()
  }
}
</script>
